import { BANKING_SCOPE } from '../types/banking-scopes'
import { deriveBankingCapabilitiesFromGrantedScopes } from './banking-capabilities-from-scopes'
import { normalizeProductOAuthSecretScopes } from './normalize-product-oauth-scopes'

/**
 * True when the secret grants at least one meaningful read or write permission.
 */
export function secretGrantsIncludeMinimumReadableAccess(
  granted: readonly string[]
): boolean {
  const normalized = normalizeProductOAuthSecretScopes(granted)
  if (normalized.length === 0) {
    return false
  }
  const caps = deriveBankingCapabilitiesFromGrantedScopes(normalized)
  if (Object.values(caps).some((t) => t !== 'none')) {
    return true
  }
  const set = new Set(normalized)
  return (
    set.has(BANKING_SCOPE.DOCUMENTS_READ) ||
    set.has(BANKING_SCOPE.DOCUMENTS_WRITE) ||
    set.has(BANKING_SCOPE.PREQUAL_READ) ||
    set.has(BANKING_SCOPE.PREQUAL_WRITE) ||
    set.has(BANKING_SCOPE.HARDPULL_READ) ||
    set.has(BANKING_SCOPE.HARDPULL_WRITE)
  )
}
